import { Box } from '@acko-tech/building-blocks.ui.common';
import { Text } from '@acko-tech/building-blocks.ui.typography';
import styled from 'styled-components';

export const TableContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 12px;
  background: #FFFFFF;
  border-radius: 16px;
  border: 1px solid var(--line-primary-n-200, #E7E7F0);
  box-sizing: border-box;
  position: relative;
  z-index: 10;
`;

export const Heading = styled(Text)`
  color: var(--text-primary-n-600, #040222);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const TableContent = styled(Box)`
  display: flex;
  gap: 24px;
  width: 100%;
  flex-direction: row;
  gap: 16px;
  padding: 16px 20px;
  width:auto;
`;

export const Column = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 12px;
`;

export const SpecItem = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SpecLabel = styled(Text)`
    color: var(--text-secondary-n-400, #5B5675);
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
`;

export const SpecValue = styled(Text)`
    color: var(--text-primary-n-600, #040222);
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
`;

export const HeadingWrapper = styled(Box)`
  padding: 12px 20px;
  background: var(--Neutral-N50, #F8F7FC);
  width: auto;
  border-radius: 15px 15px 0 0;
`;

export const DisclaimerTextContainer = styled(Box)`
  padding: 12px 20px;
  background: var(--Purple-P50, #EFE9FB);
  border-radius: 0 0 16px 16px;
  margin-top: -16px;
  z-index: 1;
  width: auto;
`;


export const DisclaimerText = styled(Text)`
  color: var(--text-primary-n-600, #040222);
  text-align: center;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-top: 12px;
  @media (min-width: 768px) {
    width: auto;
  }
`;

export const TableContainerWrapper = styled(Box)`
  margin-bottom: 25px;
`;